var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiece2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.179,
    height: 163.976,
    viewBox: "0 0 127.179 163.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mol\\xE9cule_3D",
    "data-name": "mol\\xE9cule 3D",
    transform: "translate(-146.107 -162.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M351.589,291.355c-.626-11.693-1.221-23.386-2.167-35.049a12.239,12.239,0,0,0-1.288-4.2,5.032,5.032,0,0,0-6.71-2.383,5.528,5.528,0,0,0-.544.3,43.16,43.16,0,0,0-4.134,2.927c-5.668,4.625-10.621,10.3-16.75,14.158-13.764,8.684-14.814,10.6-9.407,25.941.357,1.013.715,2.033,1.1,3.031q5.105,13.1,10.226,26.209c6.048,15.424,9.131,27.326,1.944,42.684a17.813,17.813,0,0,0-1.668,7.061c-.06,5,3.448,6.979,7.619,4.208a23.893,23.893,0,0,0,6.271-6.025c10.308-14.762,15.387-27.14,15.06-45.7-.082-4.856.156-12.669.439-18.068a145.8,145.8,0,0,0,0-15.1",
    transform: "translate(-78.492 -86.644)",
    fill: "#da1c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M318.248,431.979a56.551,56.551,0,0,0-11.552-8.185c-13.056-6.554-26.343-12.669-39.541-18.94-1.207-.573-2.488-1.013-3.634-1.475l-15.164-7.2c-5.742-2.272-11.537-4.714-17.435-6.867-9.28-3.389-17.942-2.331-25.323,4.58-7.768,7.269-11.082,16.281-8.632,26.745,3.381,14.441,16.326,24.116,33.359,24.958,21.673,1.08,43.354,1.855,65.042,2.681,5.228.2,10.472.29,15.693.1,4.067-.149,7.44-1.847,9.153-5.891,1.676-3.947,1.177-7.761-1.959-10.509",
    transform: "translate(-50.066 -121.919)",
    fill: "#da1c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M286.431,400.612a8.316,8.316,0,1,1-8.319-8.312h0a8.315,8.315,0,0,1,8.312,8.312",
    transform: "translate(-68.857 -123.176)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M286.431,400.612a8.316,8.316,0,1,1-8.319-8.312h0a8.315,8.315,0,0,1,8.312,8.312Z",
    transform: "translate(-68.857 -123.176)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiece2);
export default __webpack_public_path__ + "static/media/piece-2.852b8105a6bc6c6f2faea00c8435e596.svg";
export { ForwardRef as ReactComponent };